import React from 'react';
import HotelProductsList from './components/hotel-products-lists';

const HotelSmartersProducts: React.FC = () => {
  return (
    <div className="w-full h-full">
      <HotelProductsList />
    </div>
  );
};

export default HotelSmartersProducts;
